
define('inlineSvg!svgs/icon/external-link', function () {return '<span class="inline-external-link inline-icon"><svg width="14" height="10" viewBox="0 0 14 10"><path d="M12 1.1L8.27 4.83l.902.9L13 2.07 13.2 5h.8V.4l-.4-.4H9v.8zm-.3 5.525V8.7H1.2V2.2h5l.8-.6V1H.6l-.6.6v7.8l.6.6h11.8l.6-.6V6h-.7z"/></svg></span>';});

